module.exports = __webpack_public_path__ + "1791188489487/images/spec-bg.29bc326.png";